module.exports = __webpack_public_path__ + "first-5_microprint.jpg?97e1bf2ca869f0a2b7a09b382c88fe81";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_microprint.jpg
// module id = 585
// module chunks = 0